export default {
    "178ba26728": "了解我们的产品",
    "43bd0cb57c": "领先全行业的特色功能和服务",
    "015d1bcd47": "行业解决方案",
    "d00426bc48": "合作机构",
    "9ff28b81c4": "隐私政策  |  使用条款  |  法律法规",
    "09135b4480": "杭州同花顺数据开发有限公司版权所有",
    "603f4f1f4b": "浙ICP备15046002号 浙金信备〔2021〕1号",
    "4a7ee8f5ee": "下载APP",
    "601efab6ed": "申请试用",
    "e4cc999756": "金融数据终端",
    "49c8953b28": "覆盖股票、债券、基金、期货、指数、外汇等金融品种，提供最新最全市场行情、新闻研报、基本资料等。",
    "68051bf4aa": "数据库",
    "e5febe530a": "通过标准数据库接口为用户提供内部结构强、独立性高、对应关系明确、安全可靠、全天候的标准数据和定制数据。",
    "31f8a7a967": "数据接口",
    "8f4105595a": "提供一系列标准化数据接口满足量化投资者的基础需求，支持用户获取数据、构建量化以及策略开发。",
    "1c13a2694a": "手机APP",
    "aa9b49f713": "提供市场行情、金融资讯、智能投研工具和内容生产分发平台。",
    "74bb5fe5c1": "智能搜索",
    "fb92103b7c": "前沿机器学习技术，一个问句即可触达所需功能、数据、资讯。",
    "a56b94485d": "非结构化数据库",
    "5c7fe7de83": "智能算法技术,覆盖金融研究所需非结构化数据,助力投研,获得超额收益。",
    "fae7335381": "Chat功能，智能解答金融问题，与AI对话，获取金融资讯。",
    "c1dbcf0924": "AI写作",
    "e4cdee6595": "智能写研报，解放双手，提高效率。利用大数据和AI技术，智能生成研报内容。",
    "a13f0cfec8": "券商",
    "e31ff0f841": "支持研究、交易、财富管理等场景",
    "f14b4f28c4": "银行",
    "fb771c3a67": "支持金融市场、对公信贷、零售等领域",
    "bf8214c421": "基金",
    "e0212b388a": "支持基金投研、交易、财富管理等业务",
    "04c9e3ab21": "企业",
    "21c42cd822": "覆盖融资、同业分析、风险监控等场景",
    "c7814cb2c3": "期货",
    "ece231a465": "支持内外盘品种投研、商品套利等",
    "0d98c74797": "其他",
    "ec0572e733": "覆盖保险、资管、期货等更多领域"
}